import styled from 'styled-components/native';

import { moderateScale } from '../../../utils/scaleHelpers';

export const StyledPressable = styled.Pressable`
  margin-right: ${moderateScale(24)}px;
  opacity: ${({ $isOpaque, $pressed }) => ($isOpaque ? 0.4 : '') || ($pressed ? 0.2 : 1)};
`;
